import _extends from "@babel/runtime/helpers/extends";
/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx, css } from "@emotion/core";
import { components } from "react-select";

// These types are missing from react-select types for InputProps:
// https://github.com/DefinitelyTyped/DefinitelyTyped/blob/master/types/react-select/src/components/Input.d.ts
/**
 * @deprecated This component is being removed in V6+, February 2025, in favor of the `SelectV2/MultiSelectV2` components.
 */
export const Input = _ref => {
  let {
    children,
    ...rest
  } = _ref;
  return jsx(components.Input, _extends({}, rest, {
    css: css`
                padding-left: 6px;
                font-size: 13px;
                // Need to shift the top by a bit if we're in multiselect mode since we use a negative margin
                // fix to properly wrap the selection in MultiSelectValueContainer.
                position: relative;

                // Need to override the default line-height so we don't inherit the default 18px.
                line-height: 16px;

                ${rest.selectProps.isMulti ? "top: 4px; padding: 4px 0 6px 6px;" : ""}
            `
  }), children);
};
//# sourceMappingURL=Input.js.map